(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvHiddenInput', drvHiddenInput);

    drvHiddenInput.$inject = [];
    drvHiddenInputCtrl.$inject = [];

    /**
     * 'Hidden input' which is used for setting properties on the form where the main input control isn't a type that typically interacts with the form.
     *
     * # Scope Properties
     * {string} name - Name which will be used for the hidden input. This will be what's shown on the form.
     * {bool} invalid - Is the input in a valid state.
     */
    function drvHiddenInput() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvHiddenInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                name: '<',
                invalid: '<?'
            },
            template:
                '<input ng-show="false" name="{{drvCtrl.name}}" ng-model="unused" ng-required="drvCtrl.invalid" />'
        };
        return directive;
    }

    function drvHiddenInputCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
    }
})();